<template>
    <div v-if="chatIncluido" class="align-center d-flex justify-center" :style="containerEstilosBotao">
        <v-btn style="z-index: 9999 !important" icon x-small color="white" class="elevation-2" :style="estilosBotao" @click="posicaoToggle">
            <v-icon v-if="!botaoOcultado">mdi-close</v-icon>
            <v-icon v-else>mdi-chevron-left</v-icon>
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'NovoChatSuporte',
    data() {
        return {
            posicaoInicialBotao: 13,
            posicaoBotaoOcultado: -6,
            chatIncluido: false,
        }
    },
    computed: {
        botaoOcultado() {
            return this.posicaoInicialBotao === this.posicaoBotaoOcultado
        },
        containerEstilosBotao() {
            return {
                position: 'fixed',
                bottom: this.botaoOcultado ? '80px' : '69px',
                right: `${this.posicaoInicialBotao}px`,
            }
        },
        estilosBotao() {
            return {
                background: this.botaoOcultado ? 'var(--v-primary-base)' : 'rgba(255, 0, 0, 0.51)',
                height: this.botaoOcultado ? '40px' : '20px',
                transition: this.botaoOcultado ? 'all 0.2s ease-in-out' : '',
            }
        },
    },
    created() {
        this.incluirChat()
    },
    methods: {
        posicaoToggle() {
            this.posicaoInicialBotao = !this.botaoOcultado ? this.posicaoBotaoOcultado : 13
            this.VisibilidadeToggleWidget()
        },
        VisibilidadeToggleWidget() {
            const widgetContainer = document.querySelector('.push-widget-container')
            if (widgetContainer) {
                widgetContainer.style.display = this.posicaoInicialBotao === this.posicaoBotaoOcultado ? 'none' : 'flex'
            }
        },
        incluirChat() {
            const urlChat = this.$store.state.parametros.propriedadesCompraDiretas.linkChat
            ;(function (d, s, u, vm) {
                let h = d.getElementsByTagName(s)[0],
                    k = d.createElement(s)
                k.onload = function () {
                    let l = d.createElement(s)
                    l.src = u
                    l.async = true
                    l.onload = function () {
                        vm.verificarComponenteChat()
                    }
                    h.parentNode.insertBefore(l, k.nextSibling)
                }
                k.async = true
                k.src = 'https://storage.googleapis.com/push-webchat/wwc-latest.js'
                h.parentNode.insertBefore(k, h)
            })(document, 'script', urlChat, this)
        },
        verificarComponenteChat() {
            const intervalo = setInterval(() => {
                const componenteChat = document.querySelector('.push-widget-container')
                if (componenteChat) {
                    clearInterval(intervalo)
                    this.chatIncluido = true
                }
            }, 500)
        },
    },
}
</script>

<style scoped lang="stylus">
.push-widget-container
    z-index 9998 !important

.push-full-screen
    z-index 999 !important

.v-btn
    border-radius 50%
</style>
